// Origin for public share pages (/w/, /c/, /l/) and assets they reference.
// Must be the SPA host, not the apex: weavewords.org is IONOS domain
// forwarding to the static landing site on www, which has none of these
// routes (they ended in a 403), and Android App Links can't verify the apex
// because the verifier won't follow that redirect. Share links minted by the
// API (FRONTEND_URL) already use this host.
export const PUBLIC_APP_ORIGIN = 'https://app.weavewords.org';
